module.exports = __webpack_public_path__ + "img/touxiang.4928d58e.jpg";